export default __webpack_public_path__ + "static/media/group-of-people.ce2e809b.png";